import { render, staticRenderFns } from "./_User_dash.vue?vue&type=template&id=f7f8a028&scoped=true&"
import script from "./_User_dash.vue?vue&type=script&lang=js&"
export * from "./_User_dash.vue?vue&type=script&lang=js&"
import style0 from "./_User_dash.vue?vue&type=style&index=0&id=f7f8a028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f8a028",
  null
  
)

export default component.exports